<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="shadow-lg">
          <div class="row content-add-btn">
            <button class="btn btn-secondary" @click="$router.go(-1)">
              <em class="fa fa-chevron-left"></em>
              {{ $t('common_words.exit') }}
            </button>
          </div>
          <br />
          <form
            @submit.prevent="validateForm"
            v-if="this.isCreate() || this.isUpdate()"
          >
            <div class="row">
              <div class="col-12">
                <p>1. {{ $t('common_words.general_information2') }}</p>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <fg-input
                  type="text"
                  :label="`${$t('common_words.code')}: *`"
                  v-model="boxForm.code"
                  v-validate="modelValidations.code"
                  name="common_words.code"
                  :error="getError('common_words.code', true)"
                  placeholder="001..."
                >
                </fg-input>
              </div>
              <div class="col-12 col-md-8">
                <fg-input
                  type="text"
                  :label="`${$t('common_words.name')}: *`"
                  v-model="boxForm.name"
                  v-validate="modelValidations.name"
                  name="common_words.name"
                  :error="getError('common_words.name')"
                  :placeholder="`${$t('common_words.premium')}...`"
                >
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>2. {{ $t('common_words.data_numeric') }}</p>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <fg-input
                  type="number"
                  :label="`${$t('common_words.conversion_factor')} *`"
                  v-model="boxForm.conversion_factor"
                  v-validate="modelValidations.conversion_factor"
                  name="common_words.conversion_factor"
                  :error="getError('common_words.conversion_factor', true)"
                  placeholder="45..."
                  min="0"
                  step="0.0001"
                >
                </fg-input>
              </div>
              <div class="col-12 col-md-4">
                <fg-input
                  type="number"
                  :label="`${$t('production.minimum_weight')} *`"
                  v-model="boxForm.min_weight"
                  v-validate="modelValidations.min_weight"
                  name="production.minimum_weight"
                  :error="getError('production.minimum_weight', true)"
                  placeholder="45..."
                  min="0"
                  step="0.01"
                >
                </fg-input>
              </div>
              <div class="col-12 col-md-4">
                <fg-input
                  type="number"
                  :label="`${$t('production.maximum_weight')} *`"
                  v-model="boxForm.max_weight"
                  v-validate="modelValidations.max_weight"
                  name="production.maximum_weight"
                  :error="getError('production.maximum_weight', true)"
                  placeholder="45..."
                  min="0"
                  step="0.01"
                >
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <fg-input
                  type="number"
                  :label="`${$t('production.weight_of_tara')} *`"
                  v-model="boxForm.tara_weight"
                  v-validate="modelValidations.tara_weight"
                  name="production.weight_of_tara"
                  :error="getError('production.weight_of_tara', true)"
                  placeholder="45..."
                  min="0"
                  step="0.01"
                >
                </fg-input>
              </div>
              <div class="col-12 col-md-4 mb-3 mb-md-0">
                <label>{{ $t('labor.weight_unit') }} *</label>
                <br />
                <el-select
                  clearable
                  class="select-primary shadow-sm w-100"
                  size="large"
                  v-model="boxForm.unit_tara_weight"
                  v-validate="modelValidations.unit_tara_weight"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    class="select-primary"
                    value="kg"
                    :label="$t('common_words.kg')"
                  ></el-option>
                  <el-option
                    class="select-primary"
                    value="lb"
                    :label="$t('common_words.pounds')"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 mb-3 mb-md-0">
                <label>{{ $t('labor.length_unit') }} *</label>
                <br />
                <el-select
                  class="select-primary shadow-sm w-100"
                  size="large"
                  v-model="boxForm.unit_tara_length"
                  v-validate="modelValidations.unit_tara_length"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    class="select-primary"
                    value="cm"
                    :label="$t('common_words.centimeters')"
                  ></el-option>
                  <el-option
                    class="select-primary"
                    value="in"
                    :label="$t('common_words.inches')"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>3.{{ $t('common_words.categorization_and_types') }}</p>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="form-group has-label">
                  <label class="text-transform-none">
                    {{ $t('production.box_category') }} *
                    <a
                      v-tooltip.top-center="$t('production.boxes_manage')"
                      class="btn-info btn-simple btn-link custom-margin-actions custom-icon-size"
                      @click.prevent="openModal('box_categories')"
                    >
                      <em class="fa fa-pencil-square-o"></em>
                    </a>
                  </label>
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select cat-box shadow-sm w-100"
                    size="large"
                    v-model="boxForm.box_category_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in box_categories"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group has-label">
                  <label>{{ $t('climate.rainforest') }}</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required shadow-sm w-100"
                    size="large"
                    v-model="boxForm.rainforest"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      :label="$t('common_words.no')"
                    ></el-option>
                    <el-option
                      class="select-primary"
                      :value="1"
                      :label="$t('common_words.yes')"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group has-label">
                  <label>{{ $t('production.boxes_3lbs') }}</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required shadow-sm w-100"
                    size="large"
                    v-model="boxForm.box_3lb"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      :label="$t('common_words.no')"
                    ></el-option>
                    <el-option
                      class="select-primary"
                      :value="1"
                      :label="$t('common_words.yes')"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="form-group has-label">
                  <label>{{ $t('production.fruit_protection_bag') }}</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required shadow-sm w-100"
                    size="large"
                    v-model="boxForm.daypa"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      :label="$t('common_words.no')"
                    ></el-option>
                    <el-option
                      class="select-primary"
                      :value="1"
                      :label="$t('common_words.yes')"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>4. {{ $t('common_words.associations') }}</p>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label class="text-transform-none"
                    >{{ $t('common_words.select_a_company') }} *</label
                  >
                  <br />
                  <el-select
                    collapse-tags
                    @change="changeBusiness()"
                    clearable
                    multiple
                    class="select-primary custom-width-select fer-rels shadow-sm w-100"
                    size="large"
                    v-model="boxForm.businesses_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in businesses"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-label">
                  <label>{{ $t('common_words.farm') }} *</label>
                  <br />
                  <el-select
                    collapse-tags
                    @change="
                      selectAllFromSelect('boxForm.farms_id', getFarms())
                    "
                    clearable
                    multiple
                    filterable
                    class="select-primary custom-width-select required shadow-sm farm-fer w-100"
                    size="large"
                    v-model="boxForm.farms_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in getFarms()"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>5. {{ $t('production.others_parameters') }}</p>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="form-group has-label">
                  <label class="text-transform-none">
                    {{ $t('production.stowage_typeof') }}
                    <a
                      v-tooltip.top-center="$t('production.stowage_manage')"
                      class="btn-info btn-simple btn-link custom-margin-actions custom-icon-size"
                      @click.prevent="openModal('box_pallets')"
                    >
                      <em class="fa fa-pencil-square-o"></em>
                    </a>
                  </label>
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select pal-box shadow-sm w-100"
                    size="large"
                    v-model="boxForm.box_pallet_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in box_pallets"
                      class="select-primary"
                      :value="option.id"
                      :label="option.pallet"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group has-label">
                  <label class="text-transform-none">
                    {{ $t('production.bag') }}
                    <a
                      v-tooltip.top-center="$t('production.bags_manage')"
                      class="btn-info btn-simple btn-link custom-margin-actions custom-icon-size"
                      @click.prevent="openModal('box_bags')"
                    >
                      <em class="fa fa-pencil-square-o"></em>
                    </a>
                  </label>
                  <br />
                  <el-select
                    clearable
                    class="select-primary custom-width-select bag-box shadow-sm w-100"
                    size="large"
                    v-model="boxForm.box_bag_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in box_bags"
                      class="select-primary"
                      :value="option.id"
                      :label="option.bag"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="form-group has-label">
                  <label>{{ $t('production.corner_protection') }}</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required shadow-sm w-100"
                    size="large"
                    v-model="boxForm.mini_corners"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      :label="$t('common_words.no')"
                    ></el-option>
                    <el-option
                      class="select-primary"
                      :value="1"
                      :label="$t('common_words.yes')"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <hr />
            <br />
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-fill btn-info btn-wd shadow-sm"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
          </form>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_operations') }}
            </h5>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <el-dialog
        v-if="isUpdate()"
        width="71%"
        top="2%"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :title="titleModal"
        :visible.sync="modals.box_pallets"
        @close="handleOpenDeleteBoxPallet()"
      >
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :color="'#f18f00'"
          :is-full-page="false"
          :height="100"
          :width="255"
          :opacity="0.8"
        >
        </loading>
        <div class="row">
          <div class="col-12">
            <span style="font-size: 15px; word-break: break-word">
              1. {{ $t('production.stowage_info') }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <div class="row my-2">
              <div class="col-2 pr-0">
                <a @click="addBoxPalletRow" style="cursor: pointer">
                  <em class="fa fa-plus" style="color: #2891b0"></em
                  >{{ $t('common_words.add_record') }}
                </a>
              </div>
              <div class="col-3">
                <a
                  @click="storeUpdateAllDialog('actions-box-pallet-save')"
                  style="cursor: pointer"
                >
                  | &nbsp;&nbsp;&nbsp;&nbsp;<em
                    class="fa fa-floppy-o"
                    style="color: #20a857"
                  ></em>
                  {{ $t('common_words.save_all') }}
                </a>
              </div>
            </div>
            <el-table
              v-if="queriedData.length > 0"
              style="width: 100%"
              :data="queriedData"
              :border="true"
            >
              <el-table-column prop="businesses_id" label="Empresas">
                <template slot-scope="scope">
                  <el-select
                    @change="
                      selectAllFromSelect(
                        scope.row.businesses_id,
                        businesses,
                        scope
                      )
                    "
                    clearable
                    multiple
                    collapse-tags
                    class="select-primary custom-width-select nut-rels shadow-sm"
                    size="large"
                    v-model="scope.row.businesses_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in businesses"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="pallet"
                :label="$t('production.stowage_typeof')"
              >
                <template slot-scope="scope">
                  <el-input
                    maxlength="120"
                    show-word-limit
                    clearable
                    size="small"
                    style="text-align: center"
                    v-model="scope.row.pallet"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="30"
                :label="$t('common_words.actions')"
              >
                <template slot-scope="scope">
                  <a
                    v-if="isCreate()"
                    :finish-button-text="$t('common_words.save')"
                    class="btn-success btn-simple btn-link actions-box-pallet-save"
                    @click="storeUpdateBoxPallet(scope.$index, scope.row, true)"
                    ><em class="fa fa-floppy-o"></em>
                  </a>
                  <el-popover
                    v-model="scope.row.visible"
                    placement="top"
                    width="400"
                    trigger="manual"
                    :title="$t('production.stowage_notice')"
                  >
                    <div style="text-align: right; margin: 0">
                      <el-button
                        type="info"
                        plain
                        size="mini"
                        @click="
                          handleOpenDeleteBoxPallet(scope.$index, scope.row)
                        "
                        >{{ $t('common_words.no_thanks') }}</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="deleteBoxPallet(scope.$index, scope.row)"
                        >{{ $t('common_words.yes_delete') }}</el-button
                      >
                    </div>
                    <a
                      v-if="isCreate()"
                      v-tooltip.top-center="$t('common_words.delete')"
                      class="btn-danger btn-simple btn-link"
                      slot="reference"
                      @click="
                        handleOpenDeleteBoxPallet(scope.$index, scope.row)
                      "
                    >
                      <em class="fa fa-times"></em>
                    </a>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <hr />
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
          >
            <div class="">
              <p class="card-category" style="font-size: 14px">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              ref="paginationPallet"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
        </div>
        <hr />
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportPDF({
                    route: 'boxes/box_pallets/pdf',
                    name_file: 'tipos_estibas.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportExcel({
                    route: 'boxes/box_pallets/excel',
                    name_file: 'tipos_estibas.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </el-dialog>
      <el-dialog
        v-if="isUpdate()"
        width="74%"
        top="2%"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :title="titleModal"
        :visible.sync="modals.box_categories"
        @close="handleOpenDeleteBoxCategory()"
      >
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :color="'#f18f00'"
          :is-full-page="false"
          :height="100"
          :width="255"
          :opacity="0.8"
        >
        </loading>
        <div class="row">
          <div class="col-12">
            <span style="font-size: 15px; word-break: break-word">
              {{ $t('production.box_info') }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination1.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination1.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination1.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery1"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <div class="row my-2">
              <div class="col-2 pr-0">
                <a @click="addBoxCategoryRow" style="cursor: pointer">
                  <em class="fa fa-plus" style="color: #2891b0"></em>
                  {{ $t('common_words.add_record') }}
                </a>
              </div>
              <div class="col-3">
                <a
                  @click="storeUpdateAllDialog('actions-box-category-save')"
                  style="cursor: pointer"
                >
                  | &nbsp;&nbsp;&nbsp;&nbsp;<em
                    class="fa fa-floppy-o"
                    style="color: #20a857"
                  ></em>
                  {{ $t('common_words.save_data') }}
                </a>
              </div>
            </div>
            <el-table
              v-if="queriedData1.length > 0"
              style="width: 100%"
              :data="queriedData1"
              :border="true"
            >
              <el-table-column
                prop="businesses_id"
                :label="$t('common_words.companies')"
              >
                <template slot-scope="scope">
                  <el-select
                    @change="
                      selectAllFromSelect(
                        scope.row.businesses_id,
                        businesses,
                        scope
                      )
                    "
                    clearable
                    multiple
                    collapse-tags
                    class="select-primary custom-width-select nut-rels shadow-sm"
                    size="large"
                    v-model="scope.row.businesses_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in businesses"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('common_words.category_name')"
              >
                <template slot-scope="scope">
                  <el-input
                    maxlength="120"
                    show-word-limit
                    clearable
                    size="small"
                    style="text-align: center"
                    v-model="scope.row.name"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="30"
                :label="$t('common_words.actions')"
              >
                <template slot-scope="scope">
                  <a
                    v-if="isCreate()"
                    :finish-button-text="$t('common_words.save')"
                    class="btn-success btn-simple btn-link actions-box-category-save"
                    @click="
                      storeUpdateBoxCategory(scope.$index, scope.row, true)
                    "
                    ><em class="fa fa-floppy-o"></em>
                  </a>
                  <el-popover
                    v-model="scope.row.visible"
                    placement="top"
                    width="420"
                    trigger="manual"
                    :title="$t('production.box_notice')"
                  >
                    <div style="text-align: right; margin: 0">
                      <el-button
                        type="info"
                        plain
                        size="mini"
                        @click="
                          handleOpenDeleteBoxCategory(scope.$index, scope.row)
                        "
                        >{{ $t('common_words.no_thanks') }}</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="deleteBoxCategory(scope.$index, scope.row)"
                        >{{ $t('common_words.yes_delete') }}</el-button
                      >
                    </div>
                    <a
                      v-if="isCreate()"
                      v-tooltip.top-center="$t('common_words.delete')"
                      class="btn-danger btn-simple btn-link"
                      slot="reference"
                      @click="
                        handleOpenDeleteBoxCategory(scope.$index, scope.row)
                      "
                    >
                      <em class="fa fa-times"></em>
                    </a>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <hr />
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
          >
            <div class="">
              <p class="card-category" style="font-size: 14px">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              ref="paginationCategory"
              v-model="pagination1.currentPage"
              :per-page="pagination1.perPage"
              :total="pagination1.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
        </div>
        <hr />
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportPDF({
                    route: 'boxes/box_categories/pdf',
                    name_file: 'categorias_cajas.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportExcel({
                    route: 'boxes/box_categories/excel',
                    name_file: 'categorias_cajas.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </el-dialog>
      <el-dialog
        v-if="isUpdate()"
        width="65%"
        top="2%"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :title="titleModal"
        :visible.sync="modals.box_bags"
        @close="handleOpenDeleteBoxBag()"
      >
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :color="'#f18f00'"
          :is-full-page="false"
          :height="100"
          :width="255"
          :opacity="0.8"
        >
        </loading>
        <div class="row">
          <div class="col-12">
            <span style="font-size: 15px; word-break: break-word">
              1. {{ $t('production.bags_info') }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination2.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination2.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination2.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery2"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <div class="row my-2">
              <div class="col-2 pr-0">
                <a @click="addBoxBagRow" style="cursor: pointer">
                  <em class="fa fa-plus" style="color: #2891b0"></em>
                  {{ $t('common_words.add_record') }}
                </a>
              </div>
              <div class="col-3">
                <a
                  @click="storeUpdateAllDialog('actions-box-bag-save')"
                  style="cursor: pointer"
                >
                  | &nbsp;&nbsp;&nbsp;&nbsp;<em
                    class="fa fa-floppy-o"
                    style="color: #20a857"
                  ></em>
                  {{ $t('common_words.save_data') }}
                </a>
              </div>
            </div>
            <el-table
              v-if="queriedData2.length > 0"
              style="width: 100%"
              :data="queriedData2"
              :border="true"
            >
              <el-table-column
                prop="businesses_id"
                :label="$t('common_words.companies')"
              >
                <template slot-scope="scope">
                  <el-select
                    @change="
                      selectAllFromSelect(
                        scope.row.businesses_id,
                        businesses,
                        scope
                      )
                    "
                    clearable
                    multiple
                    collapse-tags
                    class="select-primary custom-width-select nut-rels shadow-sm"
                    size="large"
                    v-model="scope.row.businesses_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    filterable
                  >
                    <el-option
                      v-for="(option, index) in businesses"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id + '_' + index"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="bag" :label="$t('production.bag_name')">
                <template slot-scope="scope">
                  <el-input
                    maxlength="120"
                    show-word-limit
                    clearable
                    size="small"
                    style="text-align: center"
                    v-model="scope.row.bag"
                  >
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="30"
                :label="$t('common_words.actions')"
              >
                <template slot-scope="scope">
                  <a
                    v-if="isCreate()"
                    :finish-button-text="$t('common_words.save')"
                    class="btn-success btn-simple btn-link actions-box-bag-save"
                    @click="storeUpdateBoxBag(scope.$index, scope.row, true)"
                    ><em class="fa fa-floppy-o"></em>
                  </a>
                  <el-popover
                    v-model="scope.row.visible"
                    placement="top"
                    width="400"
                    trigger="manual"
                    :title="$t('production.bags_notice')"
                  >
                    <div style="text-align: right; margin: 0">
                      <el-button
                        type="info"
                        plain
                        size="mini"
                        @click="handleOpenDeleteBoxBag(scope.$index, scope.row)"
                        >{{ $t('common_words.no_thanks') }}</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="deleteBoxBag(scope.$index, scope.row)"
                        >{{ $t('common_words.yes_delete') }}</el-button
                      >
                    </div>
                    <a
                      v-if="isCreate()"
                      v-tooltip.top-center="$t('common_words.delete')"
                      class="btn-danger btn-simple btn-link"
                      slot="reference"
                      @click="handleOpenDeleteBoxBag(scope.$index, scope.row)"
                    >
                      <em class="fa fa-times"></em>
                    </a>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <hr />
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
          >
            <div class="">
              <p class="card-category" style="font-size: 14px">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              ref="paginationBag"
              v-model="pagination2.currentPage"
              :per-page="pagination2.perPage"
              :total="pagination2.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
        </div>
        <hr />
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportPDF({
                    route: 'boxes/box_bags/pdf',
                    name_file: 'bolsas.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportExcel({
                    route: 'boxes/box_bags/excel',
                    name_file: 'bolsas.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Popconfirm, Popover } from 'element-ui';
import { showContinue } from 'src/util/Util.js';
import Fuse from 'fuse.js';
import Loading from 'vue-loading-overlay';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinFarm from 'src/util/mixinFarm';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';
import { formatConversionFactor } from './formatConversionFactor';

export default {
  components: {
    Loading,
    [Popconfirm.name]: Popconfirm,
    [Popover.name]: Popover,
  },

  data() {
    return {
      title: '',
      modelCopy: {},
      boxForm: {
        unit_tara_weight: 'kg',
        unit_tara_length: 'cm',
        farms_id: [],
        box_category_id: [],
        businesses_id: [],
      },
      tableColumns: [],
      tableFormData: [],
      titleModal: '',
      modelValidations: {
        name: {
          required: true,
        },
        conversion_factor: {
          required: true,
        },
        code: {
          required: true,
        },
        tara_weight: {
          required: true,
        },
        min_weight: {
          required: true,
        },
        max_weight: {
          required: true,
        },
        unit_tara_weight: {
          required: true,
        },
        unit_tara_length: {
          required: true,
        },
      },
      boxCategoryForm: {
        name: null,
      },
      boxPalletForm: {
        name: null,
      },
      boxBagForm: {
        name: null,
      },
      modals: {
        box_categories: false,
        box_pallets: false,
        box_bags: false,
      },
      box_categories: null,
      box_pallets: null,
      box_bags: null,
      businesses: null,
      farms: null,
      addCountPallet: 0,
      addCountCategory: 0,
      addCountBox: 0,
      isLoading: false,
      searchQuery1: '',
      tableData1: [],
      fuseSearch1: null,
      searchQuery2: '',
      tableData2: [],
      fuseSearch2: null,
      pagination1: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      pagination2: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },

  computed: {
    queriedData1() {
      let result = this.tableData1;
      if (this.searchQuery1 !== '') {
        result = this.fuseSearch1.search('=' + this.searchQuery1 + '');
      }
      this.pagination1.total = result.length;
      return result.slice(this.from1, this.to1);
    },

    queriedData2() {
      let result = this.tableData2;
      if (this.searchQuery2 !== '') {
        result = this.fuseSearch2.search('=' + this.searchQuery2 + '');
      }
      this.pagination2.total = result.length;
      return result.slice(this.from2, this.to2);
    },

    pagedData1() {
      return this.tableData1.slice(this.from1, this.to1);
    },

    pagedData2() {
      return this.tableData2.slice(this.from2, this.to2);
    },

    to1() {
      let highBound = this.from1 + this.pagination1.perPage;
      if (this.total1 < highBound) {
        highBound = this.total1;
      }
      return highBound;
    },

    to2() {
      let highBound = this.from2 + this.pagination2.perPage;
      if (this.total2 < highBound) {
        highBound = this.total2;
      }
      return highBound;
    },

    from1() {
      return this.pagination1.perPage * (this.pagination1.currentPage - 1);
    },

    from2() {
      return this.pagination2.perPage * (this.pagination2.currentPage - 1);
    },

    total1() {
      this.pagination1.total = this.tableData1.length;
      return this.tableData1.length;
    },

    total2() {
      this.pagination2.total = this.tableData2.length;
      return this.tableData2.length;
    },
  },

  mixins: [
    MixinExport,
    MixinFarm,
    mixinMasters,
    MixinMenu,
    MixinForm,
    MixinNotification,
    MixinPermissions,
  ],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    openModal(name) {
      if (name == 'box_pallets') {
        this.titleModal = i18n.t('production.stowage_manage');
      }

      if (name == 'box_categories') {
        this.titleModal = i18n.t('production.boxes_manage');
      }

      if (name == 'box_bags') {
        this.titleModal = i18n.t('production.bags_manage');
      }

      this.modals[name] = true;
    },

    changeBusiness() {
      const ids = this.getFarms(true).map((farm) => farm.id);
      this.$set(
        this.boxForm,
        'farms_id',
        this.boxForm.farms_id.filter((id) => ids.includes(id))
      );
      setTimeout(() => {
        this.selectAllFromSelect('boxForm.businesses_id', this.businesses);
      }, 300);
    },

    getFarms(full = false) {
      const resp = this.getFarmListByBusinesses(
        this.farms,
        this.boxForm.businesses_id
      );

      return full ? resp : this.concatAll(resp);
    },

    handleOpenDeleteBoxBag(index, row) {
      if (row !== undefined) {
        this.tableData2.forEach((data) => {
          if (data.id && row.id && data.id === row.id)
            data.visible = !row.visible;
        });
        if (row.id === undefined) {
          const i =
            index +
            this.pagination2.perPage * (this.pagination2.currentPage - 1);
          this.$set(this.tableData2, i, { ...row, visible: !row.visible });
        }
      } else this.tableData2.forEach((data) => (data.visible = false));
    },

    handleOpenDeleteBoxCategory(index, row) {
      if (row !== undefined) {
        this.tableData1.forEach((data) => {
          if (data.id && row.id && data.id === row.id)
            data.visible = !row.visible;
        });
        if (row.id === undefined) {
          const i =
            index +
            this.pagination1.perPage * (this.pagination1.currentPage - 1);
          this.$set(this.tableData1, i, { ...row, visible: !row.visible });
        }
      } else this.tableData1.forEach((data) => (data.visible = false));
    },

    handleOpenDeleteBoxPallet(index, row) {
      if (row !== undefined) {
        this.tableData.forEach((data) => {
          if (data.id && row.id && data.id === row.id)
            data.visible = !row.visible;
        });
        if (row.id === undefined) {
          const i =
            index + this.pagination.perPage * (this.pagination.currentPage - 1);
          this.$set(this.tableData, i, { ...row, visible: !row.visible });
        }
      } else this.tableData.forEach((data) => (data.visible = false));
    },

    async storeUpdateAllDialog(className) {
      const all = document.getElementsByClassName(className);
      let row = {};
      let response = false;

      for (const [index] of Array.from(all).entries()) {
        switch (className) {
          case 'actions-box-bag-save':
            row = this.tableData2.find((_, i) => i === index);
            response = await this.storeUpdateBoxBag(index, row);
            break;

          case 'actions-box-pallet-save':
            row = this.tableData.find((_, i) => i === index);
            response = await this.storeUpdateBoxPallet(index, row);
            break;

          case 'actions-box-category-save':
            row = this.tableData1.find((_, i) => i === index);
            response = await this.storeUpdateBoxCategory(index, row);
            break;

          default:
            break;
        }

        if (!response) break;
      }
    },

    searchFuse1(keys) {
      this.fuseSearch1 = new Fuse(this.tableData1, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: keys,
      });
      this.showHideLoading();
    },

    searchFuse2(keys) {
      this.fuseSearch2 = new Fuse(this.tableData2, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: keys,
      });
      this.showHideLoading();
    },

    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.boxForm.box_category_id.length == 0) {
            this.highlightItem('cat-box');
            return false;
          } else if (this.boxForm.businesses_id.length == 0) {
            this.highlightItem('fer-rels');
            return false;
          } else if (this.boxForm.farms_id.length == 0) {
            this.highlightItem('farm-fer');
            return false;
          } else {
            this.storeUpdateBox();
          }
        }
      });
    },

    storeUpdateBox() {
      this.showHideLoading(true);
      this.boxForm.route = 'boxes/boxes';

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.boxForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.boxForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/boxes/boxes',
                null,
                false
              ).then((result) => {
                if (result.value) {
                  this.boxForm = this.modelCopy;
                  this.modelCopy = { ...this.boxForm };
                }
              });
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.boxForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/boxes/boxes',
                null,
                false
              ).then((result) => {
                if (result.value) {
                  this.boxForm = this.modelCopy;
                  this.modelCopy = { ...this.boxForm };
                }
              });
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    addBoxBagRow() {
      let newRow = { type: '', visible: false };
      this.tableData2 = [...this.tableData2, newRow];
      ++this.addCountBag;
      setTimeout(() => {
        this.pagination2.currentPage = this.$refs.paginationBag.maxPage;
      }, 150);
    },

    addBoxCategoryRow() {
      let newRow = { type: '', visible: false };
      this.tableData1 = [...this.tableData1, newRow];
      ++this.addCountCategory;
      setTimeout(() => {
        this.pagination1.currentPage = this.$refs.paginationCategory.maxPage;
      }, 150);
    },

    addBoxPalletRow() {
      let newRow = { pallet: '', visible: false };
      this.tableData = [...this.tableData, newRow];
      ++this.addCountPallet;
      setTimeout(() => {
        this.pagination.currentPage = this.$refs.paginationPallet.maxPage;
      }, 150);
    },

    storeUpdateBoxBag(index, row, closeModal = false) {
      if (row.bag != '' && row.businesses_id.length > 0) {
        this.isLoading = true;
        this.boxBagForm = row;
        this.boxBagForm.route = 'boxes/box_bags';

        if (row.id) {
          Axios.updateMaster(this.boxBagForm)
            .then((response) => {
              let index1 = this.box_bags.findIndex(
                (tableRow) => tableRow.id === this.boxBagForm.id
              );
              this.$set(this.tableData2, index, {
                ...response.data.data,
                visible: false,
              });
              this.$set(this.box_bags, index1, response.data.data);
              this.isLoading = false;
              if (closeModal) this.closeModal('box_bags');

              this.showNotification(
                `${response.data.message}`,
                'warning',
                'nc-settings-tool-66',
                ` ${i18n.t('common_words.successful_update')}...`
              );
              return true;
            })
            .catch((error) => {
              if (closeModal) this.closeModal('box_bags');
              this.showMessageErrors(error);
              return false;
            });
        } else {
          Axios.saveMaster(this.boxBagForm)
            .then((response) => {
              this.box_bags.push(response.data.data);
              this.$set(this.tableData2, index, {
                ...response.data.data,
                visible: false,
              });
              this.isLoading = false;
              if (closeModal) this.closeModal('box_bags');

              this.showNotification(
                `${response.data.message}`,
                'success',
                'nc-simple-add',
                ` ${i18n.t('common_words.successful_creation')}...`
              );
              return true;
            })
            .catch((error) => {
              if (closeModal) this.closeModal('box_bags');
              this.showMessageErrors(error);
              return false;
            });
        }
      } else if (row.bag == '' || row.bag == ' ' || row.bag == null) {
        this.showNotification(
          `El nombre de categoria no puede estar vacio`,
          'danger',
          'nc-simple-remove',
          ` ${i18n.t('common_words.alert')}...`
        );
        return false;
      } else if (row.businesses_id.length == 0) {
        this.showNotification(
          `Debe seleccionar al menos una empresa`,
          'danger',
          'nc-simple-remove',
          ` ${i18n.t('common_words.alert')}...`
        );
        return false;
      }

      return true;
    },

    storeUpdateBoxCategory(index, row, closeModal = false) {
      if (row.name != '' && row.businesses_id.length > 0) {
        this.isLoading = true;
        this.boxCategoryForm = row;
        this.boxCategoryForm.route = 'boxes/box_categories';

        if (row.id) {
          Axios.updateMaster(this.boxCategoryForm)
            .then((response) => {
              let index1 = this.box_categories.findIndex(
                (tableRow) => tableRow.id === this.boxCategoryForm.id
              );
              this.$set(this.tableData1, index, {
                ...response.data.data,
                visible: false,
              });
              this.$set(this.box_categories, index1, response.data.data);
              this.isLoading = false;
              if (closeModal) this.closeModal('box_categories');

              this.showNotification(
                `${response.data.message}`,
                'warning',
                'nc-settings-tool-66',
                ` ${i18n.t('common_words.successful_update')}...`
              );
              return true;
            })
            .catch((error) => {
              if (closeModal) this.closeModal('box_categories');
              this.showMessageErrors(error);
              return false;
            });
        } else {
          Axios.saveMaster(this.boxCategoryForm)
            .then((response) => {
              this.box_categories.push(response.data.data);
              this.$set(this.tableData1, index, {
                ...response.data.data,
                visible: false,
              });
              this.isLoading = false;
              if (closeModal) this.closeModal('box_categories');

              this.showNotification(
                `${response.data.message}`,
                'success',
                'nc-simple-add',
                ` ${i18n.t('common_words.successful_creation')}...`
              );
              return true;
            })
            .catch((error) => {
              if (closeModal) this.closeModal('box_categories');
              this.showMessageErrors(error);
              return false;
            });
        }
      } else if (row.name == '' || row.name == ' ' || row.name == null) {
        this.showNotification(
          i18n.t('show_notification.production.empty_category_name'),
          'danger',
          'nc-simple-remove',
          ` ${i18n.t('common_words.alert')}...`
        );
        return false;
      } else if (row.businesses_id.length == 0) {
        this.showNotification(
          i18n.t('show_notification.production.select_a_company'),
          'danger',
          'nc-simple-remove',
          ` ${i18n.t('common_words.alert')}...`
        );
        return false;
      }
      return true;
    },
    storeUpdateBoxPallet(index, row, closeModal = false) {
      if (row.pallet != '' && row.businesses_id.length > 0) {
        this.isLoading = true;
        this.boxPalletForm = row;
        this.boxPalletForm.route = 'boxes/box_pallets';

        if (row.id) {
          Axios.updateMaster(this.boxPalletForm)
            .then((response) => {
              let index1 = this.box_pallets.findIndex(
                (tableRow) => tableRow.id === this.boxPalletForm.id
              );
              this.$set(this.tableData, index, {
                ...response.data.data,
                visible: false,
              });
              this.$set(this.box_pallets, index1, response.data.data);
              this.isLoading = false;
              if (closeModal) this.closeModal('box_pallets');

              this.showNotification(
                `${response.data.message}`,
                'warning',
                'nc-settings-tool-66',
                ` ${i18n.t('common_words.successful_update')}...`
              );
              return true;
            })
            .catch((error) => {
              if (closeModal) this.closeModal('box_pallets');
              this.showMessageErrors(error);
              return false;
            });
        } else {
          Axios.saveMaster(this.boxPalletForm)
            .then((response) => {
              this.box_pallets.push(response.data.data);
              this.$set(this.tableData, index, {
                ...response.data.data,
                visible: false,
              });
              this.isLoading = false;
              if (closeModal) this.closeModal('box_pallets');

              this.showNotification(
                `${response.data.message}`,
                'success',
                'nc-simple-add',
                ` ${i18n.t('common_words.successful_creation')}...`
              );
              return true;
            })
            .catch((error) => {
              if (closeModal) this.closeModal('box_pallets');
              this.showMessageErrors(error);
              return false;
            });
        }
      } else if (row.pallet == '' || row.pallet == ' ' || row.pallet == null) {
        this.showNotification(
          i18n.t('show_notification.production.stowage_blank'),
          'danger',
          'nc-simple-remove',
          ` ${i18n.t('common_words.alert')}...`
        );
        return false;
      } else if (row.businesses_id.length == 0) {
        this.showNotification(
          i18n.t('show_notification.production.select_a_company'),
          'danger',
          'nc-simple-remove',
          ` ${i18n.t('common_words.alert')}...`
        );
        return false;
      }
      return true;
    },

    deleteBoxBag(index, row) {
      this.handleOpenDeleteBoxBag(index, row);
      if (row.type != '') {
        this.isLoading = true;
        this.boxBagForm = row;
        this.boxBagForm.route = 'boxes/box_bags';

        Axios.destroyMaster(this.boxBagForm)
          .then((response) => {
            let index = this.tableData2.findIndex(
              (tableRow) => tableRow.id === this.boxBagForm.id
            );

            let index1 = this.box_bags.findIndex(
              (tableRow) => tableRow.id === this.boxBagForm.id
            );

            if (index >= 0) this.tableData2.splice(index, 1);
            if (index1 >= 0) this.box_bags.splice(index1, 1);
            this.isLoading = false;

            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-remove',
              ` ${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        const i =
          index + this.pagination2.perPage * (this.pagination2.currentPage - 1);
        this.tableData2.splice(index, 1);
      }
    },

    deleteBoxCategory(index, row) {
      this.handleOpenDeleteBoxCategory(index, row);
      if (row.type != '') {
        this.isLoading = true;
        this.boxCategoryForm = row;
        this.boxCategoryForm.route = 'boxes/box_categories';

        Axios.destroyMaster(this.boxCategoryForm)
          .then((response) => {
            let index = this.tableData1.findIndex(
              (tableRow) => tableRow.id === this.boxCategoryForm.id
            );

            let index1 = this.box_categories.findIndex(
              (tableRow) => tableRow.id === this.boxCategoryForm.id
            );

            if (index >= 0) this.tableData1.splice(index, 1);
            if (index1 >= 0) this.box_categories.splice(index1, 1);
            this.isLoading = false;

            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-remove',
              ` ${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        const i =
          index + this.pagination1.perPage * (this.pagination1.currentPage - 1);
        this.tableData1.splice(i, 1);
      }
    },

    deleteBoxPallet(index, row) {
      this.handleOpenDeleteBoxPallet(index, row);
      if (row.pallet != '') {
        this.isLoading = true;
        this.boxPalletForm = row;
        this.boxPalletForm.route = 'boxes/box_pallets';

        Axios.destroyMaster(this.boxPalletForm)
          .then((response) => {
            let index = this.tableData.findIndex(
              (tableRow) => tableRow.id === this.boxPalletForm.id
            );

            let index1 = this.box_pallets.findIndex(
              (tableRow) => tableRow.id === this.boxPalletForm.id
            );

            if (index >= 0) this.tableData.splice(index, 1);
            if (index1 >= 0) this.box_pallets.splice(index1, 1);
            this.isLoading = false;
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-remove',
              ` ${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        const i =
          index + this.pagination.perPage * (this.pagination.currentPage - 1);
        this.tableData.splice(index, 1);
      }
    },

    exportPDF(data) {
      this.isLoading = true;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel(data) {
      this.isLoading = true;

      this.Excel(data)
        .then(() => {
          this.isLoading = false;
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.isLoading = false;
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    this.modelCopy = { ...this.boxForm };
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      if (sessionStorage.getItem('editForm')) {
        this.boxForm = JSON.parse(sessionStorage.getItem('editForm'));
        this.boxForm.conversion_factor = formatConversionFactor(
          this.boxForm.conversion_factor
        );
      }

      Axios.getMasters('businesses/only')
        .then((r) => {
          Axios.getMasters('boxes/box_pallets').then((r1) => {
            Axios.getMasters('boxes/box_categories').then((r2) => {
              Axios.getMasters('boxes/box_bags').then((r3) => {
                Axios.getMasters('farms/farms/only').then((r4) => {
                  this.businesses = this.concatAll(r.data.data);

                  this.tableData = r1.data.data.map((element) => {
                    element.visible = false;
                    return element;
                  });
                  this.searchFuse(['pallet']);

                  this.tableData1 = r2.data.data.map((element) => {
                    element.visible = false;
                    return element;
                  });
                  this.searchFuse1(['name']);

                  this.tableData2 = r3.data.data.map((element) => {
                    element.visible = false;
                    return element;
                  });
                  this.searchFuse2(['bag']);

                  this.box_pallets = r1.data.data;
                  this.box_categories = r2.data.data;
                  this.box_bags = r3.data.data;
                  this.farms = r4.data.data;
                  this.showHideLoading();
                });
              });
            });
          });
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
  },

  mounted() {
    this.selectedItemOnMenu('boxes');
  },

  destroyed() {
    this.deselectedItemOnMenu('boxes');
  },
};
</script>
<style scoped>
.custom-margin-actions {
  letter-spacing: normal;
  padding: 0px;
}

::v-deep .btn-info {
  border: none;
}
</style>
